// extracted by mini-css-extract-plugin
module.exports = {"privacy-phone-footer":"privacy-phone-footer_privacy-phone-footer__MWMwA","privacy-phone-footer__link":"privacy-phone-footer_privacy-phone-footer__link__r1TRi"};